export const companyInfo = {
  name: 'My Home Experts',
  tagline: 'Crafting Bespoke Luxury Homes in Sydney',
  experience: '15+',
  description: 'With over 15 years of experience in custom luxury home construction, renovations, extensions, and pool & deck installations, My Home Experts brings unparalleled craftsmanship and attention to detail to every project. We specialize in creating bespoke new home builds, modern duplexes, transforming existing spaces through luxury renovations, extending properties, and designing stunning outdoor living areas with custom pools and decks to reflect your unique vision and lifestyle.',
  phone: '0449 291 434',
  email: 'info@myhomeexperts.com.au',
  address: 'PO Box 426, ST IVES NSW 2075'
};

export const projectStages = [
  {
    id: 1,
    title: 'Initial Consultation',
    description: 'We begin with an in-depth consultation to understand your vision, requirements, and budget. Our team will discuss design preferences, timeline expectations, and site considerations.',
    duration: '1-2 weeks',
    icon: 'MessageSquare'
  },
  {
    id: 2,
    title: 'Design & Planning',
    description: 'Our architects and designers create detailed plans and 3D renderings. We work closely with you to refine every detail, ensuring the design perfectly captures your vision while meeting all regulatory requirements.',
    duration: '6-8 weeks',
    icon: 'Ruler'
  },
  {
    id: 3,
    title: 'Approvals & Documentation',
    description: 'We handle all council approvals, permits, and documentation. Our experienced team navigates the regulatory landscape, ensuring a smooth approval process with full transparency.',
    duration: '8-12 weeks',
    icon: 'FileCheck'
  },
  {
    id: 4,
    title: 'Construction',
    description: 'With meticulous attention to detail, our skilled craftsmen bring your dream home to life. We use advanced project management systems to monitor progress, maintain quality standards, and keep you informed every step of the way.',
    duration: '6-12 months',
    icon: 'Hammer'
  },
  {
    id: 5,
    title: 'Completion & Handover',
    description: 'Final inspections, quality assurance checks, and detailed walkthroughs ensure everything is perfect. We provide comprehensive documentation and after-sales support for your peace of mind.',
    duration: '2-3 weeks',
    icon: 'Home'
  }
];

export const portfolioProjects = [
  {
    id: 1,
    title: 'Bellevue Hill Estate',
    style: 'Contemporary',
    image: 'https://images.unsplash.com/photo-1678575326996-a1bf09b86158',
    description: 'Modern contemporary elegance with luxurious finishes',
    size: '650 sqm',
    year: '2024'
  },
  {
    id: 2,
    title: 'Mosman Residence',
    style: 'Contemporary',
    image: 'https://images.unsplash.com/photo-1580587771525-78b9dba3b914',
    description: 'Sophisticated contemporary architecture with clean lines',
    size: '580 sqm',
    year: '2024'
  },
  {
    id: 3,
    title: 'Bondi Modern',
    style: 'Contemporary',
    image: 'https://customer-assets.emergentagent.com/job_sydney-custom-builds/artifacts/5cdl94j1_Modern.jpg',
    description: 'Ultra-modern design with innovative architectural elements',
    size: '520 sqm',
    year: '2024'
  },
  {
    id: 4,
    title: 'Vaucluse French Estate',
    style: 'French Provincial',
    image: 'https://customer-assets.emergentagent.com/job_sydney-custom-builds/artifacts/pjypyt5m_French.jpg',
    description: 'Elegant French Provincial design with timeless charm',
    size: '720 sqm',
    year: '2024'
  },
  {
    id: 5,
    title: 'Double Bay French Villa',
    style: 'French Provincial',
    image: 'https://customer-assets.emergentagent.com/job_sydney-custom-builds/artifacts/g6oobt0t_French2.avif',
    description: 'Refined French architecture with luxury finishes',
    size: '540 sqm',
    year: '2024'
  },
  {
    id: 6,
    title: 'Toorak Classic Manor',
    style: 'Classic',
    image: 'https://customer-assets.emergentagent.com/job_sydney-custom-builds/artifacts/sd38bgra_Classic.avif',
    description: 'Timeless classic design with elegant proportions',
    size: '680 sqm',
    year: '2024'
  },
  {
    id: 7,
    title: 'Kew Classic Residence',
    style: 'Classic',
    image: 'https://customer-assets.emergentagent.com/job_sydney-custom-builds/artifacts/o8bzsruj_Classic2.jpg',
    description: 'Traditional classic architecture with modern luxury',
    size: '620 sqm',
    year: '2024'
  },
  {
    id: 8,
    title: 'Brighton Duplex',
    style: 'Duplex',
    image: 'https://customer-assets.emergentagent.com/job_sydney-custom-builds/artifacts/3jlli5dn_Duplex1.jpg',
    description: 'Contemporary duplex with elegant design and premium finishes',
    size: '480 sqm',
    year: '2024'
  },
  {
    id: 9,
    title: 'Caulfield Duplex',
    style: 'Duplex',
    image: 'https://customer-assets.emergentagent.com/job_sydney-custom-builds/artifacts/844es8pl_Duplex2.jpg',
    description: 'Modern duplex design with sophisticated styling',
    size: '450 sqm',
    year: '2024',
    imageStyle: 'contain'
  }
];

export const testimonials = [
  {
    id: 1,
    name: 'Sarah & Michael Chen',
    location: 'Mosman',
    text: 'My Home Experts transformed our vision into reality. Their attention to detail and project management throughout the construction was exceptional. We absolutely love our new home!',
    rating: 5,
    project: 'French Provincial Estate'
  },
  {
    id: 2,
    name: 'David Thompson',
    location: 'Vaucluse',
    text: 'From initial design to final handover, the team demonstrated professionalism and expertise. The quality of craftsmanship is outstanding, and their automated progress reporting kept us informed every step of the way.',
    rating: 5,
    project: 'Contemporary Residence'
  },
  {
    id: 3,
    name: 'Emma & James Wilson',
    location: 'Double Bay',
    text: 'Building our dream home was a seamless experience thanks to My Home Experts. Their 5-stage process is well-structured, and the transparency throughout construction was remarkable. Highly recommended!',
    rating: 5,
    project: 'Classic Hampton Home'
  }
];

export const heroImage = 'https://images.unsplash.com/photo-1706808849780-7a04fbac83ef';